import '../application/content_structure/breadcrumbs.js';
import '../application/content_structure/contentAudioPlayer.js';
import '../application/videos/tracking.js';
import '../application/videos/basic_test.coffee';
import '../application/videos/question.coffee';
import '../application/videos/index.coffee';
import '../application/videos/test.coffee';
import '../application/videos/ratings.js';
import '../application/components/countdown/countdown.coffee';
import '../application/videos/video_stage.js';
import '../application/videos/study_smarter_box_toast.js';
import '../application/videos/study_smarter_box_banner.js';
import '../application/videos/videos_carousel.js';
import '../application/videos/visitors/exercises_and_hints.js';
import '../application/videos/visitors/quiz_section.js';
import '../application/videos/markup_quiz.js';
import '../application/welcome/deeplinks.js';
import '../application/videos/users/video_player_overlays.coffee';
import '../application/videos/users/confirm_assign_content_popup.coffee';
import '../application/videos/visitors/learning_text_visibility_tracking.js';
import '../application/videos/visitors/click_tracking.js';

import '../application/videos/videos.sass';

// Consider to have own pricing 'plan' component
import '../application/pricing/pricing.sass';
import '../application/welcome/welcome.sass';

import '../application/components/toastComponent.js';
import '../application/videos/visitors/user_feature_buttons.js';
